var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.dismissed
    ? _c("div", { staticClass: "h-full text-white pl-ogs-large pr-12" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col h-full items-center justify-center text-xs md:text-sm font-bold",
            attrs: { id: "tickerContainer" },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasTicker,
                    expression: "hasTicker",
                  },
                ],
                staticClass: "w-full",
              },
              [
                _c("marquee-text", { attrs: { repeat: 10, duration: 20 } }, [
                  _c("span", { staticClass: "px-5" }, [
                    _vm._v(_vm._s(_vm.message)),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hasTicker,
                    expression: "!hasTicker",
                  },
                ],
                staticClass: "whitespace-no-wrap",
                attrs: { id: "tickerMessage" },
              },
              [_vm._v(_vm._s(_vm.message))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "absolute inset-y-0 right-0 flex items-center" },
          [
            _c(
              "button",
              {
                staticClass: "link w-10 h-10 flex items-center justify-center",
                on: {
                  click: function ($event) {
                    _vm.dismissed = true
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "w-3 h-3" },
                  [_c("IconCrossSmall")],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Dismiss message"),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }